import {
    Box,
    Button,
    Container,
    Flex,
    Grid,
    GridItem,
    Heading,
    HStack,
    Image,
    Link,
    Spacer,
    Stack,
    Text,
} from "@chakra-ui/react";
import Head from "next/head";
import React, { useEffect, useState } from "react";

import { Carousel } from "@/components/general/Carousel/Carousel";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const cards = [
    { titulo: "Desarrollos comercializados", content: "+160" },
    { titulo: "Desarrolladores confían en nosotros", content: "+45" },
    { titulo: "No. de colaboradores en Guía", content: "372" },
    { titulo: "No. de clientes en cartera", content: "+100 mil" },
    { titulo: "Familias beneficiadas", content: "+42.5k" },
];

const slidesDevelops = [
    {
        key: "slide-1",
        name: "",
        imageUrl: "https://media.grupoguia.mx/landings/nosotros/sliderDevelops/slideDevelop",
        icon: "",
    },
    {
        key: "slide-2",
        name: "thedistrict",
        imageUrl: "https://media.grupoguia.mx/landings/nosotros/sliderDevelops/slideDevelop",
        icon: "",
    },
    {
        key: "slide-3",
        name: "ambienta3070",
        imageUrl: "https://media.grupoguia.mx/landings/nosotros/sliderDevelops/slideDevelop",
        icon: "",
    },
    {
        key: "slide-4",
        name: "coranta",
        imageUrl: "https://media.grupoguia.mx/landings/nosotros/sliderDevelops/slideDevelop",
        icon: "",
    },
    {
        key: "slide-5",
        name: "melba",
        imageUrl: "https://media.grupoguia.mx/landings/nosotros/sliderDevelops/slideDevelop",
        icon: "",
    },
    {
        key: "slide-6",
        name: "zayma",
        imageUrl: "https://media.grupoguia.mx/landings/nosotros/sliderDevelops/slideDevelop",
        icon: "",
    },
    {
        key: "slide-7",
        name: "puntosur",
        imageUrl: "https://media.grupoguia.mx/landings/nosotros/sliderDevelops/slideDevelop",
        icon: "",
    },
    {
        key: "slide-8",
        name: "capitalnorte",
        imageUrl: "https://media.grupoguia.mx/landings/nosotros/sliderDevelops/slideDevelop",
        icon: "",
    },
    {
        key: "slide-9",
        name: "alamar",
        imageUrl: "https://media.grupoguia.mx/landings/nosotros/sliderDevelops/slideDevelop",
        icon: "",
    },
    {
        key: "slide-10",
        name: "kulkana",
        imageUrl: "https://media.grupoguia.mx/landings/nosotros/sliderDevelops/slideDevelop",
        icon: "",
    },
    {
        key: "slide-11",
        name: "laslomas",
        imageUrl: "https://media.grupoguia.mx/landings/nosotros/sliderDevelops/slideDevelop",
        icon: "",
    },
];

let iconClients = [
    {
        height: "65",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/3c.png",
    },
    {
        height: "65",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/ae.png",
    },
    {
        height: "70",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/aktie.png",
    },
    {
        height: "70",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/anida.png",
    },
    {
        height: "60",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/aron.png",
    },
    {
        height: "60",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/av.png",
    },
    {
        height: "80",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/caa.png",
    },
    {
        height: "70",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/construvida.png",
    },
    {
        height: "20",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/fibraplus.png",
    },
    {
        height: "50",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/gig.png",
    },
    {
        height: "50",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/grupocrecento.png",
    },
    {
        height: "50",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/grupoegc.png",
    },
    {
        height: "35",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/gva.png",
    },
    { height: "40", iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/gvi.png" },
    {
        height: "50",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/hitourbano.png",
    },
    {
        height: "35",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/kiva.png",
    },
    {
        height: "80",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/lech.png",
    },
    {
        height: "30",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/metropolis.png",
    },
    {
        height: "60",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/pek.png",
    },
    {
        height: "70",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/proyevaz.png",
    },
    {
        height: "50",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/sanfrancisco.png",
    },
    {
        height: "55",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/tya.png",
    },
    {
        height: "55",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderClients/valo.png",
    },
];

let iconAlliances = [
    {
        height: "40",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/avaclick.png",
    },
    {
        height: "45",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/bancompara.png",
    },
    {
        height: "42",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/briq.png",
    },
    {
        height: "50",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/builder.png",
    },
    {
        height: "30",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/casabravo.png",
    },
    {
        height: "30",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/comunidadfeliz.png",
    },
    {
        height: "35",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/datagran.png",
    },
    {
        height: "42",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/descifra.png",
    },
    {
        height: "45",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/hamoc.png",
    },
    {
        height: "40",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/hauzd.png",
    },
    {
        height: "40",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/homie.png",
    },
    {
        height: "35",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/kredi.png",
    },
    {
        height: "40",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/legalexgs.png",
    },
    {
        height: "55",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/logotipo.png",
    },
    {
        height: "45",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/lqn.png",
    },
    {
        height: "60",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/multiburo.png",
    },
    {
        height: "65",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/obralink.png",
    },
    {
        height: "75",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/outernets.co.png",
    },
    {
        height: "45",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/parkimovil.png",
    },
    {
        height: "50",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/relativity6.png",
    },
    {
        height: "35",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/wiggot.png",
    },
    {
        height: "35",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/wimet.png",
    },
    {
        height: "30",
        iconUrl: "https://media.grupoguia.mx/landings/nosotros/sliderAlliances/yotepresto.png",
    },
];

export default function Nosotros() {
    const [current, setCurrent] = useState(0);
    const current2 = 0;
    const [startIndex, setStartIndex] = useState(0);
    const [mapPoints, setMapPoints] = useState([
        {
            left: "405",
            top: "550",
            name: "puertovallarta",
            iconUrl: "https://media.grupoguia.mx/landings/nosotros/map/icon-vallarta.png",
            popover: false,
        },
        {
            left: "470",
            top: "560",
            name: "tapalpa",
            iconUrl: "https://media.grupoguia.mx/landings/nosotros/map/icon-tapalpa.png",
            popover: false,
        },
        {
            left: "470",
            top: "518",
            name: "Buscar",
            iconUrl: "https://media.grupoguia.mx/landings/nosotros/map/icon-guadalajara.png",
            popover: false,
        },
        {
            left: "545",
            top: "530",
            name: "leon",
            iconUrl: "https://media.grupoguia.mx/landings/nosotros/map/icon-leon.png",
            popover: false,
        },
        {
            left: "595",
            top: "528",
            name: "queretaro",
            iconUrl: "https://media.grupoguia.mx/landings/nosotros/map/icon-queretaro.png",
            popover: false,
        },
        {
            left: "1009",
            top: "560",
            name: "cancun",
            iconUrl: "https://media.grupoguia.mx/landings/nosotros/map/icon-cancun.png",
            popover: false,
        },
    ]);

    useEffect(() => {
        const script = document.createElement("script");
        script.src =
            "https://api.digybot.io/widget/client/tgywxsbudw-zar9w1kw6u-0r499yuc40x-9f6bxhsanr4";
        script.async = true;
        document.head.appendChild(script);
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css";
        document.head.appendChild(link);
        return () => {
            document.head.removeChild(script);
            document.head.removeChild(link);
        };
    }, []);

    const changeLeftHero = () => {
        if (current > 0) {
            setCurrent(current - 1);
        } else {
            setCurrent(slidesDevelops.length - 1);
        }
    };

    const changeRightHero = () => {
        if (current < slidesDevelops.length - 1) {
            setCurrent(current + 1);
        } else {
            setCurrent(0);
        }
    };

    const changeLeftHero2 = () => {
        if (startIndex > 0) {
            setStartIndex(startIndex - 5);
        }
    };

    const changeRightHero2 = () => {
        if (startIndex < 19) {
            setStartIndex(startIndex + 5);
        }
    };

    const handlePoint = (payload, index) => {
        let copyArr = Object.assign([], mapPoints);
        copyArr[index].popover = !payload.popover;
        setMapPoints(copyArr);
    };

    const handlePointClear = () => {
        let copyArr = Object.assign([], mapPoints);
        copyArr.forEach((element) => {
            if (element.popover === true) {
                element.popover = false;
            }
        });
        setMapPoints(copyArr);
    };

    return (
        <>
            <Head>
                <title>Nosotros | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/Nosotros" />
                <link rel="alternate" href="https://grupoguia.mx/Nosotros" hrefLang="es-mx" />
            </Head>
            <Header />
            <Container maxW="9xl">
                <Box w="full" mx="auto" maxW="3x1" paddingInline="0">
                    <Flex
                        w="100%"
                        h="85vh"
                        id="fondo"
                        backgroundImage="url(https://media.grupoguia.mx/landings/nosotros/nosotros-bg.webp)"
                        backgroundSize="cover"
                        backgroundPosition="center center"
                        backgroundRepeat="no-repeat"
                        position="relative"
                        p="0"
                        bgColor="gray.100"
                        borderRadius="10px"
                    >
                        <Flex direction="column" w="100%" position="absolute" left="0" top="38%">
                            <Stack
                                mt={15}
                                direction={{ base: "column", md: "row" }}
                                w="full"
                                maxW="6xl"
                                mx="auto"
                                align="center"
                                transitionDuration=".3s"
                                justifyContent="center"
                            >
                                <Box>
                                    <Text
                                        color="#FFFFFF"
                                        fontWeight="700"
                                        fontSize={{ base: "3xl", sm: "5xl" }}
                                        align="center"
                                    >
                                        Vive e invierte mejor
                                    </Text>
                                    <Text
                                        color="#FFFFFF"
                                        fontWeight="500"
                                        fontSize={{ base: "xl", sm: "3xl" }}
                                        textAlign="center"
                                    >
                                        {`Encuentra "el lugar para ti"`}
                                    </Text>
                                </Box>
                            </Stack>
                        </Flex>
                    </Flex>
                </Box>
            </Container>
            <Container maxW="8xl">
                <Box my={20} mx={5}>
                    <Heading
                        mt={20}
                        as="h1"
                        fontSize={{ base: "xl", md: "3xl", lg: "4xl" }}
                        textAlign="center"
                        mb="8"
                        color="accent.500"
                        fontWeight="bold"
                    >
                        Nuestros números respaldan nuestra experiencia
                    </Heading>
                    <Text
                        mt={-8}
                        textAlign="center"
                        color="accent.500"
                        fontSize={{ base: "md", md: "xl", lg: "2xl" }}
                    >
                        en la comercialización de desarrollos inmobiliarios
                    </Text>
                    <Flex mt={10}>
                        <Grid
                            mx="auto"
                            templateColumns={{
                                base: "repeat(6, 1fr)",
                                md: "repeat(9, 1fr)",
                                lg: "repeat(8, 1fr)",
                                xl: "repeat(10, 1fr)",
                            }}
                            gap={5}
                        >
                            {cards.map((item, idx) => (
                                <GridItem
                                    colSpan={{ base: 6, sm: 3, lg: 2, xl: 2 }}
                                    key={`grid-card-item-${idx}`}
                                    p={5}
                                    borderWidth="1px"
                                    borderRadius="10px"
                                    textAlign="center"
                                >
                                    <Text h="45px" align="center" fontSize="md">
                                        {item.titulo}
                                    </Text>
                                    <Text
                                        fontWeight="700"
                                        fontSize="5xl"
                                        color="rgba(25, 43, 74, 1)"
                                    >
                                        {item.content}
                                    </Text>
                                </GridItem>
                            ))}
                        </Grid>
                    </Flex>
                </Box>
            </Container>

            {/* ===== CAROUSEL DEVELOPS SECTION ===== */}
            <Container maxW="9xl">
                <Box w="100%" my={10} position="relative">
                    <Text textAlign="center" color="accent.500" fontSize="2xl">
                        Hemos comercializado más de
                    </Text>
                    <Heading
                        as="h1"
                        fontSize={{ md: "4xl", base: "2xl" }}
                        textAlign="center"
                        mb="8"
                        color="accent.500"
                        fontWeight="bold"
                    >
                        160 desarrollos con un alcance nacional
                    </Heading>
                    <Carousel current={current}>
                        {slidesDevelops.map((slide, idx) => (
                            <Flex
                                key={`development-${idx}-image`}
                                w="100%"
                                h="80vh"
                                id="fondo"
                                backgroundImage={`url(${slide.imageUrl}-${idx + 1}.webp)`}
                                backgroundSize="cover"
                                backgroundPosition="center center"
                                backgroundRepeat="no-repeat"
                                position="relative"
                                p="0"
                                borderRadius="10px"
                                cursor={slide.link ? "pointer" : "auto"}
                                onClick={() => {
                                    if (slide.link) {
                                        window.open(slide.link);
                                    }
                                }}
                                mx={5}
                            >
                                <Flex
                                    direction="row"
                                    position="absolute"
                                    w="100%"
                                    left="0"
                                    right="0"
                                    justify="center"
                                    top={slide.name === "ambienta3070" ? "30%" : "42%"}
                                    align={{ md: "start", base: "center" }}
                                    bottom={{
                                        md:
                                            slide.key !== "hero2" && slide.key !== "guiarent"
                                                ? "30"
                                                : 0,
                                        base:
                                            slide.key !== "hero2" && slide.key !== "guiarent"
                                                ? "270"
                                                : 0,
                                    }}
                                >
                                    {slide.name !== "" ? (
                                        <Image
                                            height="auto"
                                            width="250px"
                                            src={`https://media.grupoguia.mx/landings/nosotros/iconsSliderDevelops/${slide.name}.png`}
                                            alt="simple icon"
                                        />
                                    ) : null}
                                </Flex>
                            </Flex>
                        ))}
                    </Carousel>
                    <Image
                        onClick={() => changeLeftHero()}
                        src="https://media.grupoguia.mx/assets/home-page/icons/carousel/left-arrow.webp"
                        position="absolute"
                        top="55%"
                        left="5%"
                        _hover={{ cursor: "pointer" }}
                        boxSize="30px"
                        alt="icono flecha"
                    />
                    <Image
                        onClick={() => changeRightHero()}
                        src="https://media.grupoguia.mx/assets/home-page/icons/carousel/arrow-right.webp"
                        position="absolute"
                        top="55%"
                        right="5%"
                        _hover={{ cursor: "pointer" }}
                        boxSize="30px"
                        alt="icono flecha"
                    />
                    <HStack
                        position="absolute"
                        left="0"
                        right="0"
                        bottom="5.4%"
                        spacing="4%"
                        justify="center"
                    >
                        {slidesDevelops.map((item, idx) => (
                            <Box
                                key={`development-${idx}`}
                                p="6px"
                                borderRadius="15px"
                                bg={current === idx ? "#FFFFFF" : ""}
                                borderWidth="2px"
                                borderColor="#FFFFFF"
                                onClick={() => setCurrent(idx)}
                                _hover={{ cursor: "pointer" }}
                            />
                        ))}
                    </HStack>
                </Box>
            </Container>

            {/* ===== MAP SECTION ===== */}
            <Stack mt={20} align="center" w="100%" h="1100px" position="relative" overflowX="auto">
                <Heading
                    as="h1"
                    fontSize={{ md: "4xl", base: "2xl" }}
                    align="center"
                    color="accent.500"
                    fontWeight="bold"
                >
                    Presentes en varias ciudades del país
                </Heading>
                <Box
                    mt={12}
                    w="100%"
                    h="auto"
                    whiteSpace="nowrap"
                    position="relative"
                    display="flex"
                >
                    <Image
                        zIndex={1}
                        position="absolute"
                        top="50px"
                        left="0px"
                        height="auto"
                        width="100%"
                        src="https://media.grupoguia.mx/landings/nosotros/map/bg-map.webp"
                        alt="simple icon"
                    />
                    <Image
                        zIndex={2}
                        position="absolute"
                        top="150px"
                        left="0px"
                        height="700px"
                        width="100%"
                        src="https://media.grupoguia.mx/landings/nosotros/map/map.png"
                        onClick={() => handlePointClear()}
                        alt="simple icon"
                    />
                    {mapPoints.map((item, idx) => (
                        <React.Fragment key={`map-point-${idx}`}>
                            <Box
                                key={idx}
                                zIndex={3}
                                p="16px"
                                left={item.left + "px"}
                                top={item.top + "px"}
                                bg="rgba(255, 205, 0, 1)"
                                position="absolute"
                                borderRadius="20px"
                                borderWidth="2px"
                                borderColor="#FFFFFF"
                                _hover={{
                                    cursor: "pointer",
                                }}
                                onClick={() => handlePoint(item, idx)}
                            />
                            {item.popover ? (
                                <Box
                                    zIndex={4}
                                    position="absolute"
                                    left={item.left - 100 + "px"}
                                    top={item.top + "px"}
                                    bg="#FFFFFF"
                                    p={7}
                                    borderRadius="20px"
                                    borderWidth="3px"
                                    borderColor="rgba(185, 185, 185, 1)"
                                    onClick={() => handlePoint(item, idx)}
                                >
                                    <Stack align="center">
                                        <Image
                                            height="30px"
                                            maxW="190px"
                                            src={item.iconUrl}
                                            alt="simple icon"
                                        />
                                    </Stack>
                                    <Link href={`/${item.name}`}>
                                        <Button
                                            mt={4}
                                            w="200px"
                                            size="sm"
                                            rounded="full"
                                            color="#000000"
                                        >
                                            Ver más
                                        </Button>
                                    </Link>
                                </Box>
                            ) : null}
                        </React.Fragment>
                    ))}
                </Box>
            </Stack>

            {/* ===== CAROUSEL CLIENTS SECTION ===== */}
            <Container maxW="9xl">
                <Box my={10} position="relative">
                    <Carousel current={current2}>
                        <Flex
                            w="95%"
                            h="80vh"
                            id="fondo"
                            backgroundImage="url(https://media.grupoguia.mx/landings/nosotros/sliderClients/bg-sliderClients.webp)"
                            backgroundSize="cover"
                            backgroundPosition="center center"
                            backgroundRepeat="no-repeat"
                            position="relative"
                            p="0"
                            borderRadius="10px"
                            cursor="auto"
                        >
                            <Flex
                                w="100%"
                                mt={10}
                                zIndex={3}
                                align="center"
                                position="relative"
                                px={{ base: 3, md: 0 }}
                                direction="column"
                            >
                                <Box textAlign="center" mb={{ base: 4, md: 0 }}>
                                    <Text fontSize="3xl" color="#FFFFFF">
                                        Un crecimiento respaldado por
                                    </Text>
                                    <Text fontWeight="700" fontSize="3xl" color="#FFFFFF">
                                        Clientes satisfechos
                                    </Text>
                                </Box>
                                <Flex
                                    direction={{ base: "column", md: "row" }}
                                    zIndex={4}
                                    position={{ base: "relative", md: "absolute" }}
                                    top={{ base: "auto", md: "50%" }}
                                    left={{ base: "auto", md: "50%" }}
                                    transform={{ base: "none", md: "translate(-50%, -50%)" }}
                                    justifyContent="center"
                                    alignItems="center"
                                    wrap={{ base: "wrap", md: "nowrap" }}
                                    w={{ base: "100%", md: "auto" }}
                                    mt={{ base: 4, md: 0 }}
                                    gap={{ base: 2, md: 4 }}
                                >
                                    {iconClients
                                        .slice(startIndex, startIndex + 5)
                                        .map((item, idx) => (
                                            <Image
                                                key={`client-${startIndex + idx}`}
                                                pt={{ base: 5, md: 0 }}
                                                my="auto"
                                                mx={{ md: 3, xl: 10 }}
                                                height={{
                                                    base: `${item.height}px`,
                                                    md: `${item.height * 0.55}px`,
                                                    lg: `${item.height * 0.7}px`,
                                                }}
                                                src={item.iconUrl}
                                                alt="simple icon"
                                            />
                                        ))}
                                </Flex>
                            </Flex>
                        </Flex>
                    </Carousel>
                    <Image
                        onClick={() => changeLeftHero2()}
                        src="https://media.grupoguia.mx/assets/home-page/icons/carousel/left-arrow.webp"
                        position="absolute"
                        top="55%"
                        left="5%"
                        _hover={{ cursor: "pointer" }}
                        boxSize="30px"
                        alt="icono flecha"
                    />
                    <Image
                        onClick={() => changeRightHero2()}
                        src="https://media.grupoguia.mx/assets/home-page/icons/carousel/arrow-right.webp"
                        position="absolute"
                        top="55%"
                        right="5%"
                        _hover={{ cursor: "pointer" }}
                        boxSize="30px"
                        alt="icono flecha"
                    />
                </Box>

                {/* ===== CAROUSEL ALLIANCES SECTION ===== */}
                <Box my={10} position="relative">
                    <Carousel current={current2}>
                        <Flex
                            w="95%"
                            h="80vh"
                            id="fondo"
                            backgroundImage="url(https://media.grupoguia.mx/landings/nosotros/sliderAlliances/bg-sliderAlliances.webp)"
                            backgroundSize="cover"
                            backgroundPosition="center center"
                            backgroundRepeat="no-repeat"
                            position="relative"
                            p="0"
                            borderRadius="10px"
                            cursor="auto"
                        >
                            <Stack w="100%" mt={10} zIndex={3} align="center" position="relative">
                                <Box textAlign="center" mb={{ base: 4, md: 0 }}>
                                    <Text fontSize="3xl" color="#FFFFFF">
                                        Construyendo nuevos modelos de negocios y alianzas
                                        estratégicas
                                    </Text>
                                    <Text fontWeight="700" fontSize="3xl" color="#FFFFFF">
                                        Con grandes startups
                                    </Text>
                                </Box>

                                <Flex
                                    direction={{ base: "column", md: "row" }}
                                    zIndex={4}
                                    position={{ base: "relative", md: "absolute" }}
                                    top={{ base: "auto", md: "50%" }}
                                    left={{ base: "auto", md: "50%" }}
                                    transform={{ base: "none", md: "translate(-50%, -50%)" }}
                                    justifyContent="center"
                                    alignItems="center"
                                    wrap={{ base: "wrap", md: "nowrap" }}
                                    w={{ base: "100%", md: "auto" }}
                                    mt={{ base: 4, md: 0 }}
                                    gap={{ base: 2, md: 4 }}
                                >
                                    {iconAlliances
                                        .slice(startIndex, startIndex + 5)
                                        .map((item, idx) => (
                                            <Image
                                                key={`alliance-${startIndex + idx}`}
                                                pt={{ base: 2, md: 0 }}
                                                my="auto"
                                                mx={{ md: 3, xl: 8 }}
                                                height={{
                                                    base: `${item.height}px`,
                                                    md: `${item.height * 0.55}px`,
                                                    lg: `${item.height * 0.7}px`,
                                                }}
                                                width="auto"
                                                src={item.iconUrl}
                                                alt="simple icon"
                                            />
                                        ))}
                                </Flex>
                            </Stack>
                        </Flex>
                    </Carousel>
                    <Image
                        onClick={() => changeLeftHero2()}
                        src="https://media.grupoguia.mx/assets/home-page/icons/carousel/left-arrow.webp"
                        position="absolute"
                        top="55%"
                        left="5%"
                        _hover={{ cursor: "pointer" }}
                        boxSize="30px"
                        alt="icono flecha"
                    />
                    <Image
                        onClick={() => changeRightHero2()}
                        src="https://media.grupoguia.mx/assets/home-page/icons/carousel/arrow-right.webp"
                        position="absolute"
                        top="55%"
                        right="5%"
                        _hover={{ cursor: "pointer" }}
                        boxSize="30px"
                        alt="icono flecha"
                    />
                </Box>
            </Container>

            <Container maxW="8xl" my={20}>
                <Stack w="100%" align="center">
                    <Text
                        w={{ base: "100%", md: "60%" }}
                        textAlign="center"
                        color="rgba(0, 43, 73, 1)"
                        fontSize={{ base: "lg", sm: "xl", md: "2xl" }}
                    >
                        Equipamos nuestros asesores con las mejores herramientas, para que tengas
                        los mejores resultados
                    </Text>
                </Stack>
                <Flex mt={14} mx={{ base: 0, md: 40 }}>
                    <Box mr={{ base: 4, md: 0 }}>
                        <Image
                            height="auto"
                            width="155px"
                            src="https://media.grupoguia.mx/landings/nosotros/toolsAdviser/mentor.png"
                            alt="simple icon"
                        />
                    </Box>
                    <Spacer />
                    <Box mr={{ base: 4, md: 0 }}>
                        <Image
                            height="auto"
                            width="150px"
                            src="https://media.grupoguia.mx/landings/nosotros/toolsAdviser/wiggot.png"
                            alt="simple icon"
                        />
                    </Box>
                    <Spacer />
                    <Box>
                        <Image
                            height="auto"
                            width="125px"
                            src="https://media.grupoguia.mx/landings/nosotros/toolsAdviser/hubspot.png"
                            alt="simple icon"
                        />
                    </Box>
                </Flex>
                <Flex mt={16} mx={{ base: "14%", md: "28%" }}>
                    <Box mr={{ base: 16, md: 0 }}>
                        <Image
                            height="auto"
                            width="145px"
                            src="https://media.grupoguia.mx/landings/nosotros/toolsAdviser/guiarvis.png"
                            alt="simple icon"
                        />
                    </Box>
                    <Spacer />
                    <Box>
                        <Image
                            height="auto"
                            width="95px"
                            src="https://media.grupoguia.mx/landings/nosotros/toolsAdviser/vision.png"
                            alt="simple icon"
                        />
                    </Box>
                </Flex>
                <Flex pt={14}>
                    <Image
                        height="auto"
                        width="100%"
                        src="https://media.grupoguia.mx/landings/nosotros/toolsAdviser/bg-tools.png"
                        alt="simple icon"
                    />
                </Flex>
            </Container>
            <Container maxW="8xl" pt={5}>
                <Box
                    mt={10}
                    mx={10}
                    mb={20}
                    h="500px"
                    borderRightRadius="20px"
                    position="relative"
                    backgroundImage="url(https://media.grupoguia.mx/landings/nosotros/pareja-feliz.jpg)"
                    backgroundSize="cover"
                    backgroundPosition="center center"
                    backgroundRepeat="no-repeat"
                >
                    <Box
                        h="100%"
                        background="linear-gradient(to right, rgba(0,0,0,.85) 0%, rgba(0,0,0,0) 95%)"
                    >
                        <Stack
                            pt={44}
                            ml={{ base: 0, sm: 7, md: 14 }}
                            w={{ base: "100%", sm: "75%", md: "50%" }}
                            align="center"
                            justifySelf="center"
                        >
                            <Text fontSize="2xl" color="white" textAlign="center">
                                ¿Estás listo para revolucionar tus ventas?
                            </Text>
                            <Text fontSize="3xl" fontWeight="700" color="white" textAlign="center">
                                Conectamos juntos a más familias con su lugar ideal.
                            </Text>
                        </Stack>
                    </Box>
                </Box>
            </Container>
            <Footer esGuiaRent={false} />
        </>
    );
}
